const parseModuleList = (value) => {
	if (!value) return null;
	if (Array.isArray(value)) return value;
	if (typeof value === "string") {
		try {
			const parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed : null;
		} catch {
			return null;
		}
	}
	return null;
};

export const ADMIN_MODULES = [
	{ key: "ITEMS_TEXT.ANALYTICS", labelKey: "LABELS.ANALYTIC", permissionCategories: ["analytics"] },
	{ key: "ITEMS_TEXT.USERS", permissionCategories: ["user_management"] },
	{ key: "ITEMS_TEXT.ROLES", permissionCategories: ["role_management"] },
	{ key: "ITEMS_TEXT.SITES", permissionCategories: ["site_management"] },
	{ key: "ITEMS_TEXT.LINES" },
	{ key: "ITEMS_TEXT.DOCUMENTS", permissionCategories: ["document_management"] },
	{ key: "ITEMS_TEXT.MACHINE_PROVISION", permissionCategories: ["machine_provision_management"] },
	// { key: "ITEMS_TEXT.PRICE_MARKUPS", permissionKeys: ["app_settings.manage_price_markups"] },
	{ key: "ITEMS_TEXT.UPLOAD_MODELS", permissionKeys: ["app_settings.allow_model_uploads"] },
	{ key: "ITEMS_TEXT.CHANGE_PARTS", permissionKeys: ["app_settings.manage_change_parts"] },
	{
		key: "ITEMS_TEXT.SETTINGS",
		permissionKeys: ["app_settings.manage_settings", "app_settings.manage_default_values"],
	},
	{ key: "ITEMS_TEXT.POLICY_CENTER", permissionKeys: ["app_settings.manage_policy_center"] },
	{ key: "ITEMS_TEXT.COMPANY_INFORMATION", permissionKeys: ["app_settings.manage_company_info"] },
	{ key: "ITEMS_TEXT.THEME", permissionKeys: ["app_settings.manage_theme"] },
	{
		key: "ITEMS_TEXT.SCHEDULER",
		permissionKeys: [
			"order_management.create_order_schedules",
			"order_management.edit_order_schedules",
			"order_management.delete_order_schedules",
		],
	},
	{ key: "ITEMS_TEXT.ALL_PRODUCTS" },
	{ key: "ITEMS_TEXT.ALL_CUSTOMERS" },
	{ key: "ITEMS_TEXT.ALL_SITES" },
	{ key: "ITEMS_TEXT.ALL_MACHINES" },
	{ key: "ITEMS_TEXT.VERSION_INFO" },
];

export const ADMIN_MODULE_KEYS = ADMIN_MODULES.map((module) => module.key);

export const resolveEnabledAdminModules = (optionKeys) => {
	const parsed = parseModuleList(optionKeys?.adminEnabledModules);
	if (parsed) {
		return parsed.filter((key) => ADMIN_MODULE_KEYS.includes(key));
	}
	return ADMIN_MODULE_KEYS;
};

export const isAdminModuleEnabled = (key, enabledSet) => enabledSet.has(key);

export const isPermissionHiddenByModule = (category, permissionKey, enabledSet, isSuperAdmin = false) => {
	if (isSuperAdmin) return false;
	const fullKey = permissionKey ? `${category}.${permissionKey}` : null;
	return ADMIN_MODULES.some((module) => {
		if (module.key === "ITEMS_TEXT.POLICY_CENTER") return false;
		if (isAdminModuleEnabled(module.key, enabledSet)) return false;
		if (module.permissionCategories?.includes(category)) return true;
		if (fullKey && module.permissionKeys?.includes(fullKey)) return true;
		return false;
	});
};

export const isCategoryHiddenByModule = (category, enabledSet, isSuperAdmin = false) =>
	isSuperAdmin
		? false
		: ADMIN_MODULES.some((module) => {
		if (isAdminModuleEnabled(module.key, enabledSet)) return false;
		return module.permissionCategories?.includes(category);
	});